import BaseCollectionService from "./base.collection.service";

class GbsService extends BaseCollectionService {
  constructor() {
    super("gbs-help");
  }
}

export default new GbsService();
